export enum AttachmentType {
  // Todo @Muskaan - add for invoice here
  Folder = 'FOLDER',
  Task = 'TASK',
  StatusUpdate = 'STATUS_UPDATE',
  Conversation = 'PROJECT_CONVERSATIONS',
  SpaceTab = 'SPACE_TAB',
  Document = 'DOCUMENT',
  TaskConversation = 'TASK_CONVERSATION',
  SpaceTabConversation = 'SPACE_TAB_CONVERSATION',
  StatusUpdateConversation = 'STATUS_UPDATE_CONVERSATION',
}

export interface FileAttachmentRecord {
  associatedEntity?: {
    sourceType?: AttachmentType;
    sourceId: number | undefined;
  };
}

export interface FileAttachmentRequestBody extends FileAttachmentRecord {
  attachment: {
    projectId?: number;
    name: string;
    publicVisibility?: boolean;
  };
}
